import React, { useState, useContext } from "react";
import OutsideClick from "../../OutsideClick";
import Search from "../../Svgs/icon-search";
import SearchSelectStyles from "./SearchSelectInputStyles";
import InputStyles from "../InputStyles";
import AppContext from "../../../App/AppContext";
import { red, gray } from "../../../utils/styles";
import { useFormContext } from "react-hook-form";
// import propTypes from 'prop-types';

const SearchSelectInput = (props) => {
  const {
    label = "",
    register,
    formState: { errors = {} } = {},
    fieldName = "",
    placeholder = "",
    required = false,
    errorMessage = "",
    setValue,
    referenceNumber = null,
    helptext = "",
    getValues,
    onFocus,
    options,
    customError = {},
    displayOwnError = false,
  } = props;

  const { options: { primary_color = "" } = {} } = useContext(AppContext);
  const { setError } = useFormContext();

  //Object Containing Current Form Values- on 1st render this will return the default values
  const values = getValues();
  const { selectedSubstance = "" } = values;

  //state
  const [filteredOptions, setFilteredOptions] = useState(null);
  const [isDropdownActive, setIsDropdownActive] = useState(null);
  const [fieldValue, setFieldValue] = useState(selectedSubstance || "");
  const [option, setOption] = useState("");
  const [name, setName] = useState(fieldName || "");
  const [searchValue, setSearchValue] = useState("");
  const [isSearchAttempted, setIsSearchAttempted] = useState(null);
  const [shouldShowNoValueError, setShouldShowNoValueError] = useState(null);
  const [shouldShowNoOptionsError, setShouldShowNoOptionsError] =
    useState(null);

  const handleReset = (e, name) => {
    e.preventDefault();
    setOption("");
    setFieldValue("");
    setSearchValue("");
    setValue(name, "");
  };

  //on interaction
  const handleChange = (e) => {
    const searchString = e.target.value;

    // filter options as user types
    const filteredOptions = options.filter((option) => {
      const nameLowerCase = option.name.toLowerCase();
      const searchValueLowerCase = searchString.toLowerCase();
      return nameLowerCase.indexOf(searchValueLowerCase) > -1;
    });

    // show error if there's no results matching user input
    const error = filteredOptions.length <= 0 ? true : false;

    setFieldValue("");
    setShouldShowNoOptionsError(error);
    setSearchValue(searchString);
    setOption(searchString);
    setIsSearchAttempted(true);
    setFilteredOptions(filteredOptions);
  };

  const handleOutsideClick = (e) => {
    const options = fieldValue && option;
    const shouldShowNoValueError = !fieldValue && isSearchAttempted;
    setIsDropdownActive(false);
    setOption(options);
    setShouldShowNoValueError(shouldShowNoValueError);
    setShouldShowNoOptionsError(false);
    setSearchValue("");
    setFilteredOptions([]);
  };

  const handleValueUpdateOnClick = (e) => {
    const { value, option, name } = e.currentTarget.dataset;
    setFieldValue(value);
    setOption(option);
    setName(name);
    setIsDropdownActive(false);
    setShouldShowNoValueError(false);
    setValue(name, value, { shouldValidate: true });
  };

  // handle on focus in parent - example: getProviders()
  const handleOnFocus = () => {
    setIsDropdownActive(true);
    setIsSearchAttempted(true);
    setShouldShowNoValueError(false);
    setFilteredOptions(options);
    if (!onFocus) return;
    onFocus();
  };

  const handleBlur = (e) => {
    // don't show error when user clicks selection (causing blur)
    if (isDropdownActive) return;
    const error = !fieldValue && isSearchAttempted;
    setShouldShowNoValueError(error);
  };

  const renderOptions = (options) => {
    const optionList = options.map((option, index) => {
      let title = option.name.toLowerCase();
      const searchString = searchValue.toLowerCase();

      title.indexOf(searchString) > -1 &&
        (title = title.replace(
          searchString,
          `<b style='color: ${primary_color}'>${searchString}</b>`
        ));
      title = `<span style="text-transform: capitalize">${title}</span>`;

      return (
        <li
          key={`${option.value}-${index}` || `${option.name}-${index}`}
          data-value={option.value || option.name}
          data-option={option.name}
          data-name={name}
          onClick={handleValueUpdateOnClick}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      );
    });
    return optionList;
  };

  // show the filtered options as user types or all options from props
  const currentOptions = filteredOptions || options;

  return (
    <SearchSelectStyles
      tabIndex="0"
      onBlur={handleBlur}
      $primary_color={primary_color}
    >
      <div className="labels">
        <div className="label-container">
          <label
            htmlFor={fieldName}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          {required && <span className="required-asterisk">*</span>}

          {referenceNumber && (
            <span className="reference-number">{referenceNumber}</span>
          )}
        </div>

        <div
          className="helptext text-sm"
          dangerouslySetInnerHTML={{ __html: helptext }}
        />
      </div>

      <OutsideClick onClick={handleOutsideClick}>
        <div className="search-container">
          <div className="search-icon">
            <Search width={15} height={35} fill={gray(400)} />
          </div>
          <input
            tabIndex="-1"
            autoComplete="off"
            {...register(fieldName, {
              required,
            })}
            name={name}
            value={option}
            placeholder={placeholder}
            onChange={handleChange}
            onFocus={handleOnFocus}
            className={`${shouldShowNoValueError ? "error" : ""}`}
          />
          {option && (
            <div className="clear" onClick={(e) => handleReset(e, name)}>
              clear
            </div>
          )}
        </div>

        {isDropdownActive && (
          <div className="options">
            <ul>
              {currentOptions?.length > 0 && renderOptions(currentOptions)}

              {shouldShowNoOptionsError && (
                <>
                  <li
                    style={{
                      fontWeight: "bold",
                      color: red(),
                    }}
                  >
                    {customError ? (
                      <span
                        style={{
                          color: red(),
                          fontSize: "12px",
                        }}
                      >
                        {customError?.errorMessage}
                      </span>
                    ) : (
                      <span style="font-size: 12px">
                        No options found. Please check your spelling.
                      </span>
                    )}

                    {customError && (
                      <div
                        style={{
                          color: gray(400),
                          marginTop: "6px",
                          fontSize: "12px",
                        }}
                      >
                        {customError?.errorOptionsTitle}
                      </div>
                    )}
                  </li>
                  {customError && renderOptions(customError?.errorOptions)}
                </>
              )}
            </ul>
          </div>
        )}
      </OutsideClick>
      {errors[fieldName] && displayOwnError === true && (
        <span className="input-error">{errorMessage}</span>
      )}
    </SearchSelectStyles>
  );
};

export default SearchSelectInput;

// SearchSelectInput.propTypes = {
//     style: propTypes.object,
//     label: propTypes.string.isRequired,
//     formState: propTypes.object,
//     fieldName: propTypes.string.isRequired,
//     placeholder: propTypes.string.isRequired,
//     required: propTypes.bool,
//     errorMessage: propTypes.string.isRequired,
//     setValue: propTypes.func.isRequired,
//     referenceNumber: propTypes.number,
//     getValues: propTypes.func.isRequired,
//     onFocus: propTypes.func,
//     options: propTypes.array.isRequired,
//     customError: propTypes.shape({
//         errorOptionsTitle: propTypes.string.isRequired,
//         errorMessage: propTypes.string.isRequired,
//         errorOptions: propTypes.arrayOf(
//             propTypes.shape({
//                 name: propTypes.string.isRequired,
//             }),
//         ),
//     }).isRequired,
//     displayOwnError: propTypes.bool,
// };
